import React from "react";
import { Button } from "antd";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div
      style={{
        padding: "50px",
        textAlign: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f5f5",
        color: "#333",
      }}
    >
      <h1 style={{ fontSize: "72px", margin: "0", color: "#1890ff" }}>404</h1>
      <h2>页面未找到</h2>
      <p>抱歉，您访问的页面不存在。</p>
      <Button
        type="primary"
        style={{ marginTop: "20px" }}
      >
        <Link
          to="/"
          style={{ color: "inherit", textDecoration: "none" }}
        >
          返回首页
        </Link>
      </Button>
    </div>
  );
};

export default NotFound;
